import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppComponent } from './app.component';
// Modules
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { MaterialModule } from './material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GoogleChartsModule } from 'angular-google-charts';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FormsModule } from '@angular/forms';
import { AuthInterceptor } from './core/interceptors/api.interceptor';
// import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import { AuthGuardApp } from './core/guards/auth.guard';
import { MatDialogRef } from '@angular/material/dialog';
// import {OfferDbModule} from './modules/offerdb/offerdb.module';
import { DatePipe } from '@angular/common';
import { EmptyRouteComponent } from './empty-route.component';
import {
  NgxUiLoaderModule,
  NgxUiLoaderRouterModule,
  NgxUiLoaderConfig,
  POSITION,
  SPINNER,
  NgxUiLoaderService,
} from 'ngx-ui-loader';
import { OverlayContainer } from '@angular/cdk/overlay';
import { MicrofrontendOverlayContainer } from './custom-overlay';
import { EnvServiceProvider } from './env.service.provider';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
// import { FormioModule } from '@formio/angular';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { DevTokenInterceptor } from './devtoken.interceptor';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  fgsColor: '#ffffff',
  pbColor: '#ffffff',
  fgsPosition: POSITION.centerCenter,
  fgsSize: 100,
  fgsType: SPINNER.threeStrings, // foreground spinner type
  pbThickness: 5, // progress bar thickness
};

@NgModule({
  declarations: [AppComponent, EmptyRouteComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,
    MaterialModule,
    BrowserAnimationsModule,
    GoogleChartsModule,
    ScrollingModule,
    FormsModule,
    NgxUiLoaderRouterModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxDaterangepickerMd.forRoot(),
  ],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: DevTokenInterceptor, multi: true },{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }, { provide: MatDialogRef, useValue: {} }, { provide: OverlayContainer, useClass: MicrofrontendOverlayContainer }, AuthGuardApp, DatePipe, NgxUiLoaderService, EnvServiceProvider, provideHttpClient(withInterceptorsFromDi()),provideCharts(withDefaultRegisterables())] })
export class AppModule {}
